
export class ReviewQuestionAnswerDbDto {
    constructor(public questionId: string, public answer: boolean | undefined) {}
}

export class ReviewDbDto {
    public _id: string;
    public assignedTo: string;
    public codeAuthor: string;
    public repoName: string;
    public tag: string;
    public hash: string;
    public codeAuthorName: string;
    public dueDate: Date;
    public submittedDate: Date | undefined;
    public answers: ReviewQuestionAnswerDbDto[] = [];
    public reviewPassed: boolean | undefined;
    public reviewAccepted: boolean | undefined;
}
